<div class="modal-header justify-content-end">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <div class="edit-tools clearfix">
    <div class="tool wave-type">
      <b>Wave type</b>
      <select name="wave_type" class="form-control" [(ngModel)]="clip.pattern">
        <option *ngFor="let item of getWaveTypes()" [ngValue]="item.slug">{{ item.title }}</option>
      </select>
    </div>
    <div class="tool wave-color" [ngClass]="{'active' : colorToggle}"
         [(colorPicker)]="clip.color"
         [cpPosition]="'bottom'"
         [cpPositionOffset]="'50%'"
         [cpPositionRelativeToArrow]="true"
         (cpToggleChange)="colorToggle = $event"></div>
    <div class="tool wave-color" [ngClass]="{'active' : colorMiddleToggle}" *ngIf="clip.pattern === 'dot'"
         [(colorPicker)]="clip.colorMiddle"
         [cpPosition]="'bottom'"
         [cpPositionOffset]="'50%'"
         [cpPositionRelativeToArrow]="true"
         (cpToggleChange)="colorMiddleToggle = $event"></div>
    <div class="tool wave-color" [ngClass]="{'active' : colorEndToggle}" *ngIf="clip.isGradient || clip.pattern === 'dot'"
         [(colorPicker)]="clip.colorEnd"
         [cpPosition]="'bottom'"
         [cpPositionOffset]="'50%'"
         [cpPositionRelativeToArrow]="true"
         (cpToggleChange)="colorEndToggle = $event"></div>
    <ng-container *ngIf="clip.pattern === 'bars'">
      <div class="tool wave-type">
        <b>Gradient</b>
        <input type="checkbox"  [(ngModel)]="clip.isGradient" name="autosave"/>
      </div>
      <div class="tool wave-type">
          <b>Tiny bars</b>
          <input type="checkbox"  [(ngModel)]="clip.isTiny" name="autosave"/>
      </div>
      <div class="tool wave-type">
          <b>Mirror bars</b>
          <input type="checkbox" [(ngModel)]="clip.isMirror" name="autosave"/>
      </div>
      <div class="tool wave-type">
        <b>Frequency</b>
        <input type="checkbox" [(ngModel)]="clip.useFrequency" name="autosave"/>
      </div>
    </ng-container>

    <ng-container *ngIf="clip.pattern === 'siri'">
      <div class="tool wave-type">
        <b>Colored</b>
        <input type="checkbox"  [(ngModel)]="clip.isTiny" name="autosave"/>
      </div>
    </ng-container>
  </div>
</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-default" (click)="activeModal.dismiss('Cancel click')">{{ 'CANCEL' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="finishTextEditing()">{{ 'OK' | translate }}</button>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/audiogram-editor/audiogram-editor.component.html